import { ISketch } from '@lifk/types'
import { Position } from 'geojson'

const PREFIX = 'site-thumbnail'
export const DRAFT_SITE_THUMBNAIL_ID = 'draft-site'

export const getThumbnailCacheKey = (siteId: string, coordinates: Position[]) =>
  `${PREFIX}:${siteId}:${JSON.stringify(coordinates)}`

export const clearDraftThumbnailCache = () => {
  Object.keys(localStorage)
    .filter((key) => key.startsWith(`${PREFIX}:${DRAFT_SITE_THUMBNAIL_ID}:`))
    .forEach((key) => localStorage.removeItem(key))
}

export const clearSiteThumbnailCache = (
  editedSite: ISketch,
  clearAll = false
) => {
  // clearAll deletes all thumbnails, including the current coords (eg after delete).
  // clearAll = false deletes only out of date thumbnails, keeping the current version (eg after update).
  Object.keys(localStorage)
    .filter(
      (key) =>
        key.startsWith(`${PREFIX}:${editedSite._id}:`) &&
        (clearAll ||
          key !== getThumbnailCacheKey(editedSite._id, editedSite.coordinates))
    )
    .forEach((key) => localStorage.removeItem(key))
}
